import { BCDataGrid } from '@bimser/components';
import DataGrid2 from '../../..';
import { IControlProperties } from '../../../../../../../entities';
import { IDataGridColumn } from '../../../entities';

export const getHeaderFilterComponent = (
	dataGrid: DataGrid2,
	bcColumn: IDataGridColumn<IControlProperties>
) => {
	if (dataGrid.filtering.headerFilterEnabled && bcColumn.headerFilterEnabled) {
		return <BCDataGrid.Components.HeaderFilter />;
	}
};
